var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('public-page',[_c('div',{staticClass:"terms"},[_c('quick-links-card')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }